export const GoogleMapsRegex = /^(https:\/\/maps\.app\.goo\.gl\/|https:\/\/maps\.google\.com\/|https:\/\/www\.google\.com)/;
export const ArabicNameRegex = /^[\u0600-\u06FF0-9\s\-,().]*$/
export const EnglishNameRegex = /^[A-Za-z0-9\s\-,().]*$/

export const PasswordRegex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/
export const qrCodeUrlRegex = /^(https?:\/\/)?(?:([\w.-]+):([\w.-]+)@)?([\w.-]+\.[a-z]{2,})(:\d+)?(\/[^\s?#]*)?(\?[^\s#]*)?$/
export const phoneNumberRegex = /^5\d{8}$/






